module.exports = __webpack_public_path__ + "static/media/flow-sms.23d3a596.png";